import { render } from "./AnimeTitleWithStore.vue?vue&type=template&id=2a3fdd24&scoped=true"
import script from "./AnimeTitleWithStore.vue?vue&type=script&lang=js"
export * from "./AnimeTitleWithStore.vue?vue&type=script&lang=js"

import "./AnimeTitleWithStore.vue?vue&type=style&index=0&id=2a3fdd24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3fdd24"]])

export default __exports__